var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seckill-header"},[_c('scroll-view',{ref:"tabWrap",staticClass:"tab-wrap",attrs:{"scroll-x":""}},_vm._l((_vm.formatTabList),function(tab,index){return _c('div',{key:tab.scene_id,class:[
        'tab',
        tab.status !== 2 ? 'will-start' : '',
        _vm.activeIndex === index ? 'active' : '',
        _vm.formatTabList.length < 5 ? 'average' : ''
      ],on:{"click":function($event){$event.stopPropagation();return _vm.switchTab(index, $event, tab)}}},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(tab.tabTime))]),_c('span',{staticClass:"status-str"},[_vm._v(_vm._s(tab.statusStr))])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }